import { render, staticRenderFns } from "./ServiceNavbarExtensions.vue?vue&type=template&id=ea28d324&scoped=true"
import script from "./ServiceNavbarExtensions.vue?vue&type=script&lang=ts"
export * from "./ServiceNavbarExtensions.vue?vue&type=script&lang=ts"
import style0 from "./ServiceNavbarExtensions.vue?vue&type=style&index=0&id=ea28d324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea28d324",
  null
  
)

export default component.exports